import type {
  ICustomerPaymentMethodsPresentation,
} from '@/domain/stripe/customer/sub-domains/paymentMethod/presentation/contract/ICustomerPaymentMethodsPresentation'

export class CustomerPaymentMethodsFailurePresentation extends Error implements ICustomerPaymentMethodsPresentation {

}
